export class CustomerStyle {
    public static positions:string[] = ['top', 'bottom', 'left', 'right'];
    public static sizes:string[] = ['width', 'height', 'min-width', 'min-height', 'max-width', 'max-height'];
    public static margins:string[] = ['margin', 'margin-left', 'margin-right', 'margin-top', 'margin-bottom'];

    public static colors:string[] = ['background', 'background-color', 'background-image', 'background-repeat', 'background-position', 'color'];
    public static borders:string[] = ['border', 'border-left', 'border-right', 'border-top', 'border-bottom', 'border-radius', 'box-shadow'];

    public static getStyleList(seekList:string[]):string[] {
        let list:string[] = [];

        for(let seek of seekList) {
            if(CustomerStyle[seek] != undefined) {
                list = list.concat(CustomerStyle[seek]);
            }
        }

        return list;
    }

    public static get sizesPositionsMargins():string [] {
        return CustomerStyle.getStyleList(['sizes', 'positions', 'margins']);
    }

    public static get positionsMargins():string [] {
        return CustomerStyle.getStyleList(['positions', 'margins']);
    }

    public static get sizesColorsBorders():string [] {
        return CustomerStyle.getStyleList(['sizes', 'colors', 'borders']);
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/models/customer-style.ts